export const getPcMenuTree = {
  url: '/admin/resource/pc/tree.json',
  method: 'get'
};

export const savePcMenu = {
  url: '/admin/resource/pc/save.json',
  method: 'post'
};

export const deletePcMenu = {
  url: '/admin/resource/pc/delete.json',
  method: 'post'
};

export const sortPcMenu = {
  url: '/admin/resource/pc/sort.json',
  method: 'post'
};

export const getBuiltinRoleList = {
  url: '/admin/role/builtin/list.json',
  method: 'get'
};

export const getBuiltinRoleMenuTree = {
  url: '/admin/role/builtin/menuTree.json',
  method: 'get'
};

export const saveBuiltinRoleMenu = {
  url: '/admin/role/builtin/saveMenu.json',
  method: 'post'
};
